<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-title :style="{textAlign: 'center'}">Relatórios</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-list :style="{paddingStart: '8px', paddingEnd: '8px', background: 'transparent'}">
        <template v-for="(report, index) in computedReports" :key="index">
          <ion-card @click="showReport(report.id)" class="ion-activatable ripple-parent" style="margin-bottom: 8px;">
            <ion-ripple-effect></ion-ripple-effect>
            <ion-card-title class="ion-padding">
              <ion-grid class="ion-no-padding">
                <ion-row class="ion-no-padding">
                  <!-- <ion-col size="1">
                    <ion-icon v-if="report.iconMobile" :icon="icons[report.ionIcon]"></ion-icon>
                  </ion-col> -->
                  <ion-col size="11">
                    <ion-label>{{ report.title || report.name }}</ion-label>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </ion-card-title>
          </ion-card>
        </template>
      </ion-list>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonHeader,
  IonToolbar,
  IonTitle,
  IonList,
  IonCard,
  IonCardTitle,
  // IonCardContent,
  IonLabel,
  IonPage,
  IonContent,
  // IonIcon,
  IonGrid,
  IonRow,
  IonCol,
  IonRippleEffect,
} from "@ionic/vue";
// import {} from "ionicons/icons"
import store from "../../store";
import { mapMutations } from 'vuex'

export default {
  name: "ReportsList",
  props: ["reports"],
  components: {
    IonHeader,
    IonToolbar,
    IonTitle,
    IonList,
    IonCard,
    IonCardTitle,
    // IonCardContent,
    IonLabel,
    IonPage,
    IonContent,
    // IonIcon,
    IonGrid,
    IonRow,
    IonCol,
    IonRippleEffect,
  },
  watch: {
    $route() {
      if (this.computedMyRoute) {
        this.setSyncable(false)
      }
    }
  },
  computed: {
    computedMyRoute() {
      return this.$route.path.includes('report')
    },
    computedReports() {
      return this.reports.filter(report => report.active)
    },
    computedIcons() {
      return icons
    }
  },
  methods: {
    ...mapMutations(['setSyncable']),
    showReport(reportId) {
      const path = store.$router.currentRoute.value.path;
      store.$router.push(path + "/detalhes/" + reportId);
    },
  },
  created() {
    if (this.computedMyRoute) this.setSyncable(false)
  }
};
</script>

<style scoped>
  ion-card-title {
    font-size: 1.2em;
  }
</style>